/**
 * Created by pajicv on 10/12/18.
 */

import React from 'react';
import { Paper, Modal, Typography, Button, withStyles } from '@material-ui/core';
import ProjectCycles from './ProjectCycles.enhancer';
import classnames from 'classnames';
import ForwardIcon from '@material-ui/icons/ArrowForward';
import BackIcon from '@material-ui/icons/ArrowBack';
import CyclesBar from './CyclesBar';

const styles = theme => ({
  paper: {
    background: '#fff',
    padding: 10,
    width: '90%',
    position: 'absolute',
    top: 100,
    bottom: 10,
    left: '50%',
    transform: 'translate(-50%, 0)'
  },
  multiShadow: {
    boxShadow: `0 1px 1px rgba(0,0,0,0.15),
                    0 10px 0 -5px #eee,
                    0 10px 1px -4px rgba(0,0,0,0.15),
                    0 20px 0 -10px #eee,
                    0 20px 1px -9px rgba(0,0,0,0.15)`,
  },
  oneShadow: {
    boxShadow: `0 1px 1px rgba(0,0,0,0.15),
                    0 10px 0 -5px #eee,
                    0 10px 1px -4px rgba(0,0,0,0.15)`
  },
  button: {
    position: 'absolute',
    width: 40,
    height: 40
  },
  upperRight: {
    top: 100,
    right: -50,
  },
  upperLeft: {
    top: 100,
    left: -50,
  }
});

class CyclesHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCycle: props.selectedCycle
    };
  }

    handlePreviousClick = () => {
      const { selectedCycle } = this.state;
      const { cycles, activeCycle, onClose } = this.props;
      const selectedCycleIndex = cycles[selectedCycle].index;
      const newIndex = selectedCycleIndex + 1;
      if(newIndex > Object.keys(cycles).length) {
          return;
      }
      const newCycle = Object.keys(cycles).find((cycleId) => {
          return cycles[cycleId].index === newIndex;
      });
      if(newCycle !== activeCycle) {
          this.setState({selectedCycle: newCycle});
      } else {
          onClose();
      }
    };

    handleNextClick = () => {
        const { selectedCycle } = this.state;
        const { cycles } = this.props;
        const selectedCycleIndex = cycles[selectedCycle].index;
        const newIndex = selectedCycleIndex - 1;
        if(newIndex < 0) {
            return;
        }
        const newCycle = Object.keys(cycles).find((cycleId) => {
            return cycles[cycleId].index === newIndex;
        });
        this.setState({selectedCycle: newCycle});
    };

    handleCycleClick = (selectedCycle) => {
        const {activeCycle, onClose} = this.props;
        if(activeCycle !== selectedCycle) {
            this.setState({ selectedCycle });
        } else {
            onClose();
        }
    };

    render() {
      const { open, onClose, cycles, classes, project, history } = this.props;
      const { selectedCycle } = this.state;
      const selectedCycleIndex = cycles[selectedCycle].index;
      const numberOfCycles = Object.keys(cycles).length;

      let renderedCycles = <Typography>There are no previous cycles in project</Typography>;
      if (numberOfCycles > 1) {
        renderedCycles = (
                <Paper className={classes.paper}>
                    <div style={{width: '100%', height: '100%', overflow: 'auto'}}>
                        <ProjectCycles key={selectedCycle} history={history} cycleId={selectedCycle} projectTitle={project.title} index={selectedCycleIndex} />
                    </div>
                    <Button
                      variant="fab"
                      className={classnames(classes.button, classes.upperRight)}
                      onClick={this.handleNextClick}
                    >
                        <ForwardIcon />
                    </Button>
                    <Button
                      variant="fab"
                      className={classnames(classes.button, classes.upperLeft)}
                      onClick={this.handlePreviousClick}
                    >
                        <BackIcon />
                    </Button>
                    <CyclesBar selectedCycle={selectedCycle} cycles={cycles} onCycleClick={this.handleCycleClick}  />
                </Paper>
        );
      }

      return (
            <Modal
              className={classes.modal}
              open={open}
              onClose={onClose}
            >
                {renderedCycles}
            </Modal>
      );
    }
}

export default withStyles(styles)(CyclesHistory);

/*
 let shadows = '';
 if(index >= 2) {
 shadows = classes.multiShadow;
 } else if(index === 1) {
 shadows = classes.oneShadow;
 } else {
 shadows = classes.paper;
 }
 */



// WEBPACK FOOTER //
// ./src/components/Cycles/CyclesHistory.js